import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const deliveryMethodApi = createApi({
  reducerPath: 'deliveryMethodeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['deliveryMethod'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getDeliveryMethodList: builder.query({
      query: () => ({
        method: 'GET',
        path: `DeliveryFormats`,
      }),
      providesTags: ['deliveryMethod'],
    }),
    createNewDeliveryMethod: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'DeliveryFormats',
      }),
      invalidatesTags: ['deliveryMethod'],
    }),
    updateDeliveryMethod: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: `DeliveryFormats`,
      }),
      invalidatesTags: ['deliveryMethod'],
    }),
    deleteDeliveryMethod: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `DeliveryFormats/${id}`,
      }),
      invalidatesTags: ['deliveryMethod'],
    }),
  }),
});

export const deliveryMethodApiReducerName = deliveryMethodApi.reducerPath;
export const deliveryMethodApiReducer = deliveryMethodApi.reducer;
export const deliveryMethodApiMiddleware = deliveryMethodApi.middleware;

export const {
  useGetDeliveryMethodListQuery,
  useCreateNewDeliveryMethodMutation,
  useUpdateDeliveryMethodMutation,
  useDeleteDeliveryMethodMutation,
} = deliveryMethodApi;
